module.exports = {"title":"Social networks with a hashtag #Stop_E40"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/social-feeds.en.json
// module id = 182
// module chunks = 0